if (!customElements.get('expandable-text')) {
  class ExpandableText extends HTMLElement {
    connectedCallback() {
      const lines = this.getAttribute('lines') || 6;
      this.style.setProperty('--expandable-text-lines', lines);

      const content = document.createElement('div');
      content.className = 'expandable-text__content';
      content.id = content.id || `expandable-text-content-${Math.random().toString(36).slice(2)}`;
      content.innerHTML = this.innerHTML;
      this.innerHTML = '';
      this.appendChild(content);

      const readMore = this.dataset.readMore || 'Read more';
      const readLess = this.dataset.readLess || 'Read less';

      let toggle = null;

      const updateToggle = () => {
        const isExpanded = this.classList.contains('is-expanded');
        // While expanded, clamp is removed so scrollHeight === clientHeight — temporarily re-clamp to measure
        if (isExpanded) content.style.display = '-webkit-box';
        const overflows = content.scrollHeight > content.clientHeight;
        if (isExpanded) content.style.display = '';

        if (overflows && !toggle) {
          toggle = document.createElement('button');
          toggle.type = 'button';
          toggle.className = 'expandable-text__toggle link-s-suisse link-underline';
          toggle.textContent = isExpanded ? readLess : readMore;
          toggle.setAttribute('aria-expanded', isExpanded);
          toggle.setAttribute('aria-controls', content.id);
          toggle.addEventListener('click', () => {
            const expanded = this.classList.toggle('is-expanded');
            toggle.textContent = expanded ? readLess : readMore;
            toggle.setAttribute('aria-expanded', expanded);
          });
          this.appendChild(toggle);
        } else if (!overflows && toggle) {
          toggle.remove();
          toggle = null;
          this.classList.remove('is-expanded');
        }
      };

      const observer = new ResizeObserver(() => updateToggle());
      observer.observe(content);
      this._resizeObserver = observer;
    }

    disconnectedCallback() {
      this._resizeObserver?.disconnect();
    }
  }

  customElements.define('expandable-text', ExpandableText);
}
